var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 36 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30.22 5.03h-7.545v5.029h7.544v40.234H5.073V10.059h7.544v-5.03H5.073a5.03 5.03 0 0 0-5.03 5.03v40.234a5.03 5.03 0 0 0 5.03 5.03h25.146a5.03 5.03 0 0 0 5.03-5.03V10.059a5.03 5.03 0 0 0-5.03-5.03M17.645 15.087a5.03 5.03 0 1 1 0 10.059 5.03 5.03 0 0 1 0-10.06m10.059 20.117H7.587V32.69c0-3.344 6.715-5.029 10.059-5.029 3.345 0 10.059 1.685 10.059 5.03zm0 7.544H7.587v-2.515h20.118zm-10.059 5.03H7.587v-2.515h10.059zm2.515-37.72h-5.03V0h5.03z"
  })));
};
export default SvgProfile;